module.exports = __webpack_public_path__ + "img/chengguozh1.2811ea37.webp";